<template>
  <div
    class="infinite-list"
    v-infinite-scroll="loadMore"
    infinite-scroll-distance="10"
    :style="{ height: this.clientHeight + 'px' }"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div
      v-for="(item, index) in exList"
      class="m-item"
      :key="index"
      @click="linkToArea(item)"
    >
      <div class="mi-left">
        <img :src="item.logo" v-if="item.logo" />
      </div>
      <div class="mi-right">
        <h4>{{ item.name }}</h4>
        <p>
          时间：{{ item.startTime | moment("YYYY/MM/DD ") }} ~
          {{ item.endTime | moment("MM/DD") }}
        </p>
        <p>地点：{{ item.address }}</p>
      </div>
    </div>
    <div class="empty" v-if="finish">你已经到底了 ~</div>
    <div class="empty" v-if="empty">暂无数据</div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      page: 0,
      size: 10,
      totalCount: 0,
      count: 0,
      exList: [],
      finish: false, // 加载完成状态
      empty: false, // 空数据状态
      clientHeight: 600, // 空数据状态
      loading: true,
    };
  },
  created() {
    document.title = "选择展会";
    this.clientHeight = document.documentElement.clientHeight || 600;
  },
  methods: {
    ...mapMutations({
      setHostExhibition: "hostSetModule/setHostExhibition",
    }),
    ...mapActions({
      applyOMGetAll: "mobileBackend/applyOMGetAll",
    }),
    loadMore() {
      if (this.exList.length && this.exList.length >= this.totalCount) {
        this.finish = true;
        return;
      }
      this.page += 1;
      this.init();
    },
    async init() {
      let res = await this.applyOMGetAll({
        pageIndex: this.page,
        pageSize: this.size,
      });
      if (res && res.items.length > 0) {
        if (this.page === 0) {
          this.exList = [...res.items];
        } else {
          this.exList = [...this.exList, ...res.items];
        }
        this.totalCount = res.totalCount;
        if (this.exList.length === 0) {
          this.empty = true;
        }
      }
      if (res) {
        this.loading = false;
      }
    },
    linkToArea(item) {
      console.log("选择的展会", item);
      this.$router.push("/mobile-backend/ex-area-list?id=" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.infinite-list {
  overflow: auto;
  padding: 15px 15px 0;
}
.m-item {
  min-height: 90px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  .mi {
    &-left {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      margin-right: 10px;
      font-size: 0;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-right {
      min-height: 70px;
      width: calc(100% - 80px);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-around;
      h4 {
        width: 100%;
        font-size: 15px;
        font-weight: normal;
        color: #333;
        margin-bottom: 5px;
      }
      p {
        width: 100%;
        font-size: 12px;
        color: #666;
      }
    }
  }
}
.empty {
  line-height: 100px;
  text-align: center;
  color: #ccc;
}
</style>
